var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9257 14.5933C15.1028 14.2189 15.5499 14.0589 15.9244 14.236L21.0186 16.6455C21.2808 16.7695 21.4479 17.0335 21.4479 17.3235V27.4689C21.4479 27.8831 21.1121 28.2189 20.6979 28.2189C20.2837 28.2189 19.9479 27.8831 19.9479 27.4689V17.7985L15.283 15.592C14.9086 15.4149 14.7486 14.9678 14.9257 14.5933Z",
    fill: "#CFD0E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7461 9.7718L4.59548 14.8858L14.7461 19.842L24.8967 14.8858L14.7461 9.7718ZM15.106 7.71366C14.8796 7.59959 14.6126 7.59959 14.3861 7.71366L1.53504 14.1882C0.944195 14.4859 0.94947 15.3313 1.54398 15.6215L14.3951 21.8962C14.6166 22.0044 14.8756 22.0044 15.0971 21.8962L27.9482 15.6215C28.5427 15.3313 28.548 14.4859 27.9571 14.1882L15.106 7.71366Z",
    fill: "#CFD0E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98242 16.7605H6.98242V22.5242C9.19891 23.9896 12.0311 24.7268 14.8675 24.7165C17.7005 24.7062 20.447 23.951 22.5083 22.5364V16.7605H24.5083V23.5424L24.1143 23.8425C21.6 25.7577 18.2303 26.7043 14.8748 26.7165C11.5167 26.7287 8.06993 25.8057 5.39347 23.8552L4.98242 23.5556V16.7605Z",
    fill: "#CFD0E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6972 29.9024C20.9345 29.9024 21.1269 29.71 21.1269 29.4728C21.1269 29.2355 20.9345 29.0431 20.6972 29.0431C20.4599 29.0431 20.2676 29.2355 20.2676 29.4728C20.2676 29.71 20.4599 29.9024 20.6972 29.9024ZM20.6972 31.4024C21.763 31.4024 22.6269 30.5385 22.6269 29.4728C22.6269 28.407 21.763 27.5431 20.6972 27.5431C19.6315 27.5431 18.7676 28.407 18.7676 29.4728C18.7676 30.5385 19.6315 31.4024 20.6972 31.4024Z",
    fill: "#CFD0E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingIcon);
export default __webpack_public_path__ + "static/media/training_icon.2a30eb544c8184043b05eae2f4095ffc.svg";
export { ForwardRef as ReactComponent };